<div [ngClass]="{ 'group_input': true, 'invalid': ((model.control.dirty || model.control.touched) &&  (invalid | async)) }">
  <input type="text" [(ngModel)]="value" [matDatepicker]="picker" (click)="picker.open()" [attr.required]="required" [max]="maxDate"/>
  <span class="bar"></span>
  <label><span *ngIf="required">* </span>{{ title }}</label>
  <mat-datepicker [startView]="startView" #picker></mat-datepicker>
</div>
